import { Accept } from 'react-dropzone'

export const fileMimeTypes: Accept = {
  'application/vnd.ms-excel': [],
  'application/msword': [],
  'text/plain': [],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
  'application/rtf': [],
  'application/pdf': [],
  'image/jpeg': [],
  'image/jpg': [],
  'image/jpe': [],
  'image/png': [],
  'image/gif': [],
  'image/webp': [],
  'image/tiff': [],
  'image/tif': [],
  'image/psd': [],
  'image/raw': [],
  'image/bmp': [],
  'image/heif': [],
  'image/jp2': [],
  'image/j2k': [],
  'image/svg+xml': [],
  'image/svgz': [],
  'image/ai': [],
  'image/eps': [],
  'image/jpf': [],
  'image/jpx': [],
  'image/jpm': [],
  'image/mj2': [],
  'image/heic': [],
  'image/dib': [],
  'image/arw': [],
  'image/cr2': [],
  'image/nrw': [],
  'image/k25': [],
  'video/quicktime': [],
  'video/mp4': [],
}

export enum LocationDocumentTypes {
  CompanyDocument = 'CompanyDocument',
  LocationDocument = 'LocationDocument',
}
